module.exports = {
	init: () => {
		window.jQuery(() => {
			window.jQuery('#show_edit').on('click', function () {
				window.jQuery(this).addClass('hidden');
				window.jQuery('#edit_form').removeClass('hidden');
				return false;
			});

			window.jQuery('#cancel').on('click', function () {
				window.jQuery('#show_edit').removeClass('hidden');
				window.jQuery('#edit_form').addClass('hidden');
				window.jQuery('#display_name').html(window.jQuery('#display_name').data('lastsave'));
			});

			window.jQuery('#editline1,#editline2').on('keyup', compose);
			window.jQuery('.deg, .jdeg').on('click', compose);

			if (window.iq.show_edit_on_load) {
				window.jQuery('#show_edit').trigger('click');
			}
		});
	}
};

function compose() {
	window.jQuery('#display_name_warning').hide();
	var str = window.jQuery('#editline1').val().trim();

	// append checked degree years
	var d = window.jQuery('.deg:checkbox:checked');
	$.each(d, function (key, deg) {
		str += " '" + deg.value;
	});
	if (str.length > 35) {
		window.jQuery('#display_name_warning').show();
	} else {
		window.jQuery('#line1').val(str);
	}
	var composed_line_1 = str.substring(0, 34);

	// append line 2 if present
	if (window.jQuery('#editline2').length > 0) {
		str = window.jQuery('#editline2').val().trim();
	} else {
		str = '';
	}

	// append checked degree years
	var d = window.jQuery('.jdeg:checkbox:checked');
	$.each(d, function (key, deg) {
		str += " '" + deg.value;
	});
	if (str.length > 35) {
		window.jQuery('#display_name_warning').show();
	} else {
		// console.log(str);
		window.jQuery('#line2').val(str);
	}
	var composed_line_2 = str.substring(0, 34);

	if (composed_line_2.length === 0) {
		window.jQuery('#display_name').html(composed_line_1);
	} else {
		window.jQuery('#display_name').html(composed_line_1 + '<br />&nbsp;&nbsp;' + composed_line_2);
	}
}
